import BaseEntity from '../../base/BaseEntity.model';
import Direccion from '@/models/direccion.model';

export default class TramiteReevaluacionHogar extends BaseEntity {
    public tramiteBeneficiarioId?: number;
    public hogarId?: number;
    public icv?: number;
    public fechaLevantamiento?: Date;
    public personaId?: number;
    public direccion?: Direccion;
    
    constructor(public direccionId: number|undefined = undefined) {
        super();
        this.tramiteBeneficiarioId = undefined;
        this.personaId = undefined;
        this.icv = undefined;
        this.fechaLevantamiento = undefined;
        this.hogarId = undefined;
        this.direccion = undefined;
    }
}